var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"embed-responsive preview-iframe-w"},[_c('iframe',{ref:"iframe",staticClass:"embed-responsive-item",attrs:{"src":_vm.src},on:{"load":_vm.updateData}})])}
var staticRenderFns = []

export { render, staticRenderFns }